import { css } from 'styled-components/macro';

export const tooltipcss = css`
  z-index: 2;
  width: 340px;
  display: flex;
  font-size: 12px;
  background: #fff;
  position: absolute;
  padding: 16px 25px;
  border-radius: 20px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 1px 14px rgba(0, 0, 0, 0.12);

  @media (max-width: 767px) {
    padding: 0;
    box-shadow: none;
    position: initial;
  }
`;

export const tooltiprowcss = (header: boolean, color: string) => css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${header ? color : '#626262'};
  font-size: ${header ? '12px' : '10px'};
  font-weight: ${header ? '700' : '400'};
  margin: ${header ? '5px 0 10px 0;' : '5px 0'};

  ${color !== '#d1d1d1'
    ? `> div:first-of-type {
    width: 70%;
  }`
    : ''}
`;
